export interface CompanyListing {
  rank: number
  name: string
  score: number
  badge: 'TOP PICK' | 'Excellent' | 'Good'
  stars: number
  features: string[]
  offer: string
  partnerRoute?: string
  logoUrl?: string
}

export interface ServiceListings {
  serviceSlug: string
  serviceName: string
  description: string
  companies: CompanyListing[]
}

export const compareListings: ServiceListings[] = [
  {
    serviceSlug: 'walk-in-showers',
    serviceName: 'Walk-In Showers',
    description:
      'Avoid overspending on walk-in shower installation. See how our reviewers ranked the top walk-in shower companies in your area below.',
    companies: [
      {
        rank: 1,
        name: 'Kohler Walk-In Shower',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Luxurious Reveal™ shower designs',
          'Custom-fit to your bathroom',
          'Low-maintenance LuxStone™ walls',
          'Quick professional installation',
          'Wide range of style options',
          '$1,000 Off Your Shower Remodel',
        ],
        offer: '$1,000 Off + No Payments for 12 Months',
        partnerRoute: '/kohler/showers',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/9h5yrMBK8hbAbnoQyJRvQs/Kohler_logo.png',
      },
    ],
  },
  {
    serviceSlug: 'walk-in-tubs',
    serviceName: 'Walk-In Tubs',
    description:
      'Find the best walk-in tub companies near you. Our reviewers evaluated safety features, hydrotherapy options, and installation quality.',
    companies: [
      {
        rank: 1,
        name: 'Kohler Walk-In Bath',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Hydrotherapy & BubbleMassage jets',
          'Ultra-low 3-inch step-in',
          'Heated backrest & surfaces',
          'Quick-drain technology',
          'Multifunction handshower included',
          'Lifetime limited warranty',
        ],
        offer: '$1,000 Off + No Payments for 18 Months',
        partnerRoute: '/kohler/walk-in-tubs',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/9h5yrMBK8hbAbnoQyJRvQs/Kohler_logo.png',
      },
      {
        rank: 2,
        name: 'Baths R Us',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Walk-in tub specialists',
          'One-day installation available',
          'ADA-accessible options',
          'Durable, low-maintenance materials',
          'Lifetime warranty on products',
          'Licensed & insured professionals',
        ],
        offer: '$1,000 Off Walk-In Tub Installation',
        partnerRoute: '/baths-r-us/walk-in-tubs',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/ww2rdwZ9zBytie27eikQmU/Baths_r_us_lgo.webp',
      },
    ],
  },
  {
    serviceSlug: 'stairlifts',
    serviceName: 'Stairlifts',
    description:
      'Compare the top-rated stairlift companies. Our experts evaluated safety, reliability, and value to help you choose the best option.',
    companies: [
      {
        rank: 1,
        name: 'Acorn Stairlifts',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Straight & curved stair models',
          'Battery backup for power outages',
          'Slim fold-away design',
          'Safety sensors on carriage & footrest',
          'Fast installation — often next day',
          'Industry-leading warranty',
        ],
        offer: '$250 Off + Free In-Home Survey',
      },
      {
        rank: 2,
        name: 'Bruno Stairlifts',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Made in the USA',
          'Whisper-quiet operation',
          'Offset swivel seat at top landing',
          '400 lb weight capacity available',
          'Covered gear rack for safety',
        ],
        offer: 'Free Home Assessment Today',
      },
      {
        rank: 3,
        name: 'Harmar Stairlifts',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Affordable pricing options',
          'Outdoor models available',
          'Retractable seat belt standard',
          'Easy-to-use armrest controls',
          'Nationwide service network',
        ],
        offer: 'Financing From $89/Month',
      },
    ],
  },
  {
    serviceSlug: 'window-replacement',
    serviceName: 'Window Replacement',
    description:
      'Avoid overspending on replacement windows for your home. See how our reviewers ranked the top window replacement and installation companies in your area below.',
    companies: [
      {
        rank: 1,
        name: 'Champion Windows',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Fast local pricing for windows',
          'Various window styles and options',
          'Energy efficient windows',
          'As little as 1-day installation',
          'Competitive warranties available',
          'Save Big On Windows Today',
        ],
        offer: 'Save Big On Windows Today',
        partnerRoute: '/champion/windows',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/qx5Lg8aAYGUHHWyYpDu3qx/ChampionLogo_GDI_Primary.png',
      },
      {
        rank: 2,
        name: 'DaBella Windows',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Premium vinyl window options',
          'Energy-efficient double & triple pane',
          'Professional installation crews',
          'Lifetime limited warranty',
          'Free in-home consultation',
          'Financing options available',
        ],
        offer: '$1,000 Off Window Replacement',
        partnerRoute: '/dabella/windows',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/qpzVzhypzNbXmPMfecWDrq/debella_logo.svg',
      },
      {
        rank: 3,
        name: 'K-Designers Windows',
        score: 9.5,
        badge: 'Good',
        stars: 5,
        features: [
          'Over 140,000 satisfied customers',
          'Custom-fit window solutions',
          'Energy-efficient designs',
          'Professional installation',
          'Competitive warranties available',
          'Serving homeowners since 1978',
        ],
        offer: 'Special Savings on Windows',
        partnerRoute: '/k-designers/windows',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/idrKUKYXCqVbysWS3F6st9/K_Designers_Logo.png',
      },
      {
        rank: 4,
        name: 'Universal Windows Direct',
        score: 9.6,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Exclusive UniShield® windows',
          'True Lifetime Warranty',
          'Expert factory-trained installers',
          'Energy-efficient solutions',
          'Flexible financing options',
          'Award-winning customer service',
        ],
        offer: 'Buy 1 Get 1 FREE on Windows',
        partnerRoute: '/universal-windows-direct/windows',
      },
    ],
  },
  {
    serviceSlug: 'gutter-guards',
    serviceName: 'Gutter Guards',
    description:
      'Stop cleaning your gutters forever. See how our reviewers ranked the best gutter guard installation companies near you.',
    companies: [
      {
        rank: 1,
        name: 'All American Gutter Protection',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Stainless steel micro-mesh',
          'Works on all roof types',
          'No-clog performance guarantee',
          'Veteran-owned company',
          'Competitive pricing',
          'Free Gutter Inspection + Quote',
        ],
        offer: 'Free Gutter Inspection + Quote',
        partnerRoute: '/all-american-gutter/gutter-guards',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/uf1Vk4MkCjKVeK9UQc7vGE/Guggere_image.webp',
      },
      {
        rank: 2,
        name: 'Universal Windows Direct',
        score: 9.6,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Premium gutter protection systems',
          'True Lifetime Warranty',
          'Expert factory-trained installers',
          'Prevents clogs and water damage',
          'Flexible financing options',
          'Award-winning customer service',
        ],
        offer: 'Special Savings on Gutters',
        partnerRoute: '/universal-windows-direct/gutters',
      },
    ],
  },
  {
    serviceSlug: 'roofing',
    serviceName: 'Roofing',
    description:
      'Protect your home with a quality roof. See how our reviewers ranked the top roofing contractors and companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'DaBella Roofing',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'GAF Master Elite® certified contractor',
          'Premium shingle options available',
          'Full roof system installation',
          'Comprehensive workmanship warranty',
          'Free drone roof inspection',
          'Financing options available',
        ],
        offer: '$1,000 Off Full Roof Replacement',
        partnerRoute: '/dabella/roofing',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/qpzVzhypzNbXmPMfecWDrq/debella_logo.svg',
      },
    ],
  },
  {
    serviceSlug: 'siding',
    serviceName: 'Siding',
    description:
      "Transform your home's exterior with new siding. See how our reviewers ranked the top siding installation companies near you.",
    companies: [
      {
        rank: 1,
        name: 'DaBella Siding',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium vinyl & fiber cement options',
          'Insulated siding for energy savings',
          'Color that never needs painting',
          'Lifetime limited warranty',
          'Expert installation crews',
          'Free in-home consultation',
        ],
        offer: '$1,500 Off Whole-Home Siding',
        partnerRoute: '/dabella/siding',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/qpzVzhypzNbXmPMfecWDrq/debella_logo.svg',
      },
      {
        rank: 2,
        name: 'Champion Siding',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Premium exterior siding options',
          'Energy-efficient insulated siding',
          'Fade-resistant color technology',
          'Professional installation',
          'Competitive warranties available',
          'A Great Day Improvements brand',
        ],
        offer: 'Save Big On Siding Today',
        partnerRoute: '/champion/siding',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/qx5Lg8aAYGUHHWyYpDu3qx/ChampionLogo_GDI_Primary.png',
      },
      {
        rank: 3,
        name: 'K-Designers Siding',
        score: 9.5,
        badge: 'Good',
        stars: 5,
        features: [
          'Over 140,000 satisfied customers',
          'Custom siding solutions',
          'Energy-efficient options',
          'Professional installation crews',
          'Serving homeowners since 1978',
          'Competitive pricing available',
        ],
        offer: 'Special Savings on Siding',
        partnerRoute: '/k-designers/siding',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/idrKUKYXCqVbysWS3F6st9/K_Designers_Logo.png',
      },
      {
        rank: 4,
        name: 'Universal Windows Direct',
        score: 9.6,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Exclusive UniShield® siding',
          'True Lifetime Warranty',
          'Expert factory-trained installers',
          'Energy-efficient solutions',
          'Flexible financing options',
          'Award-winning customer service',
        ],
        offer: 'Special Savings on Siding',
        partnerRoute: '/universal-windows-direct/siding',
      },
    ],
  },
  {
    serviceSlug: 'solar',
    serviceName: 'Solar Panels',
    description:
      'Go solar and save on energy bills. See how our reviewers ranked the top solar panel installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'SunPower',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Highest efficiency panels on the market',
          '25-year complete confidence warranty',
          'Sleek all-black panel design',
          'Integrated battery storage options',
          'Professional design & installation',
          'Industry-leading energy production',
        ],
        offer: 'Get 30% Federal Tax Credit + $0 Down',
      },
      {
        rank: 2,
        name: 'Tesla Solar',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Low-profile panel design',
          'Powerwall battery integration',
          'Price-match guarantee',
          'Mobile app monitoring',
          'Simple online ordering',
        ],
        offer: 'Price Match Guarantee + Free Powerwall',
      },
      {
        rank: 3,
        name: 'ADT Solar',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Backed by ADT brand trust',
          'Premium panel options',
          '25-year warranty coverage',
          'Flexible financing available',
          'Nationwide installation network',
        ],
        offer: '$0 Down Solar Installation',
      },
    ],
  },
  {
    serviceSlug: 'bathroom-remodel',
    serviceName: 'Bathroom Remodel',
    description:
      'Create your dream bathroom. See how our reviewers ranked the top bathroom remodeling companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Baths R Us',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Full bathroom transformations',
          'One-day tub & shower installs available',
          'Durable, low-maintenance materials',
          'ADA-accessible options',
          'Lifetime warranty on products',
          'Licensed & insured professionals',
        ],
        offer: '$1,000 Off Complete Remodel',
        partnerRoute: '/baths-r-us/bathroom-remodel',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/ww2rdwZ9zBytie27eikQmU/Baths_r_us_lgo.webp',
      },
      {
        rank: 2,
        name: 'K-Designers Bathroom',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Complete bathroom remodeling',
          'Over 140,000 satisfied customers',
          'Custom design solutions',
          'Professional installation',
          'Competitive warranties available',
          'Serving homeowners since 1978',
        ],
        offer: 'Special Savings on Bathroom Remodel',
        partnerRoute: '/k-designers/bathroom',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/idrKUKYXCqVbysWS3F6st9/K_Designers_Logo.png',
      },
    ],
  },
  {
    serviceSlug: 'kitchen-remodel',
    serviceName: 'Kitchen Remodel',
    description:
      'Revitalize the heart of your home. See how our reviewers ranked the top kitchen remodeling companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Kitchen Magic',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Cabinet refacing saves 50% vs. replacing',
          'Granite & quartz countertop options',
          'Custom storage solutions',
          'Professional design team included',
          'Lifetime warranty on refacing',
          'Financing from $99/month',
        ],
        offer: 'Up To $3,000 Off Kitchen Remodel',
      },
      {
        rank: 2,
        name: 'N-Hance Wood Refinishing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Cabinet refinishing in 1-2 days',
          'Fraction of replacement cost',
          'Eco-friendly lightspeed® finish',
          'Color change options available',
          'Nationwide franchise network',
        ],
        offer: 'Free Color Consultation + Estimate',
      },
      {
        rank: 3,
        name: 'CliqStudios',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Custom cabinetry at fair prices',
          'Free 3D kitchen design',
          'Solid wood construction',
          'Soft-close doors & drawers standard',
          'Delivered to your door',
        ],
        offer: '40% Off MSRP + Free Design',
      },
    ],
  },
  {
    serviceSlug: 'flooring',
    serviceName: 'Flooring',
    description:
      'Upgrade your floors with confidence. See how our reviewers ranked the top flooring installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Floor Coverings International',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Shop-at-home convenience',
          'Next-day professional installation',
          'Hundreds of styles in stock',
          'All-inclusive pricing — no hidden fees',
          'Satisfaction guarantee included',
          'Financing options available',
        ],
        offer: 'Buy One Room, Get One Free',
        partnerRoute: '/fci/flooring',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/5wpLpVezYeAkEh7NG2YmbK/FCI_Logo.webp',
      },
    ],
  },
  {
    serviceSlug: 'hvac',
    serviceName: 'HVAC',
    description:
      'Keep your home comfortable year-round. See how our reviewers ranked the top HVAC installation and repair companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Trane Comfort Specialists',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium Trane equipment',
          'Up to 22 SEER2 efficiency ratings',
          'Factory-trained technicians',
          '12-year limited warranty',
          'Smart thermostat integration',
          'Financing as low as 0% APR',
        ],
        offer: '$1,500 Off New System + Free Thermostat',
      },
      {
        rank: 2,
        name: 'Carrier Factory Authorized',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Carrier brand reliability',
          'Energy Star® certified systems',
          'Indoor air quality solutions',
          '10-year parts warranty',
          'Same-day service available',
        ],
        offer: 'Up To $1,200 In Rebates',
      },
      {
        rank: 3,
        name: 'Lennox Premier Dealers',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Quietest systems available',
          'iComfort smart technology',
          'Variable-speed compressors',
          'Comprehensive maintenance plans',
          'Satisfaction guarantee',
        ],
        offer: 'Special Financing For 60 Months',
      },
    ],
  },
  {
    serviceSlug: 'painting',
    serviceName: 'Painting',
    description:
      'Refresh your home with a professional paint job. See how our reviewers ranked the top painting companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'CertaPro Painters',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Largest residential painting company',
          'Detailed written estimates',
          'Premium Sherwin-Williams paints',
          'Interior & exterior specialists',
          'Satisfaction guarantee included',
          'Fully licensed & insured',
        ],
        offer: '10% Off Your First Project',
      },
      {
        rank: 2,
        name: 'Five Star Painting',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Free color consultations',
          'Eco-friendly paint options',
          'On-time guarantee',
          'Background-checked painters',
        ],
        offer: 'Free Estimate + Color Consultation',
      },
      {
        rank: 3,
        name: 'Paintzen',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Instant online quotes',
          'Vetted professional painters',
          'Premium Benjamin Moore paints',
          'Hassle-free booking',
          'Satisfaction guaranteed',
        ],
        offer: 'Book Online & Save $100',
      },
    ],
  },
  {
    serviceSlug: 'plumbing',
    serviceName: 'Plumbing',
    description:
      'Fix leaks and upgrade your plumbing. See how our reviewers ranked the top plumbing service companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Roto-Rooter',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Available 24/7/365',
          'Over 85 years of experience',
          'Flat-rate pricing — no surprises',
          'Licensed & insured plumbers',
          'Drain cleaning specialists',
          'Satisfaction guaranteed',
        ],
        offer: '$50 Off Any Plumbing Service',
      },
      {
        rank: 2,
        name: 'Mr. Rooter Plumbing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Neighborly® brand trusted',
          'Upfront, flat-rate pricing',
          'No overtime charges — ever',
          'Full-service plumbing',
          'Courteous, uniformed plumbers',
        ],
        offer: 'Free Plumbing Inspection',
      },
      {
        rank: 3,
        name: 'Benjamin Franklin Plumbing',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          "On-time guarantee or you don't pay",
          'Straightforward pricing',
          'Background-checked technicians',
          'Residential & commercial',
          'Financing available',
        ],
        offer: '$25 Off First Service Call',
      },
    ],
  },
  {
    serviceSlug: 'electrical',
    serviceName: 'Electrical',
    description:
      'Keep your home safe and powered. See how our reviewers ranked the top electrical service companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Mr. Electric',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Upfront pricing — no surprises',
          'Licensed master electricians',
          'Residential & commercial services',
          'Code compliance experts',
          'Satisfaction guaranteed',
        ],
        offer: '$50 Off Any Electrical Service',
      },
      {
        rank: 2,
        name: 'Mister Sparky',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'On-time guarantee',
          'Flat-rate pricing always',
          'Safety inspections available',
          'EV charger installation',
          'Background-checked electricians',
        ],
        offer: 'Free Home Safety Inspection',
      },
      {
        rank: 3,
        name: 'Arc Angel Electric',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Panel upgrades & rewiring',
          'Smart home installation',
          'Generator installation',
          'Surge protection specialists',
          'Flexible scheduling',
        ],
        offer: '10% Off Panel Upgrades',
      },
    ],
  },
  {
    serviceSlug: 'fencing',
    serviceName: 'Fencing',
    description:
      'Add privacy and security to your property. See how our reviewers ranked the top fence installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: "Lowe's Fence Installation",
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Trusted national brand',
          'Wide selection of materials & styles',
          'Professional installation included',
          'Competitive pricing guaranteed',
          'Project financing available',
          'Free in-store consultations',
        ],
        offer: '10% Off Fence Installation',
      },
      {
        rank: 2,
        name: 'Home Depot Fencing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Huge material selection',
          'Licensed local installers',
          'Free project estimates',
          'Wood, vinyl, chain link & more',
          'Installation warranty included',
        ],
        offer: 'Free Delivery On Materials',
      },
      {
        rank: 3,
        name: 'Ergeon Fencing',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Instant online quotes',
          'AI-powered project planning',
          '3D fence visualization',
          'Vetted local contractors',
          'Price-lock guarantee',
        ],
        offer: 'Get Instant Quote Online',
      },
    ],
  },
  {
    serviceSlug: 'insulation',
    serviceName: 'Insulation',
    description:
      'Lower your energy bills with proper insulation. See how our reviewers ranked the top insulation companies near you.',
    companies: [
      {
        rank: 1,
        name: 'USA Insulation',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium injection foam insulation',
          'Reduces energy bills up to 40%',
          'No demolition or mess',
          'Lifetime warranty included',
          'Free energy assessment',
          'Financing options available',
        ],
        offer: '10% Off Whole-Home Insulation',
      },
      {
        rank: 2,
        name: 'Dr. Energy Saver',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Comprehensive energy audits',
          'Spray foam & blown-in options',
          'Attic, wall & crawl space experts',
          'Certified energy specialists',
          'Measurable energy savings',
        ],
        offer: 'Free Energy Audit ($500 Value)',
      },
      {
        rank: 3,
        name: 'Installed Building Products',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Largest insulation installer in US',
          'All insulation types available',
          'New construction & retrofit',
          'Commercial & residential',
          'Nationwide coverage',
        ],
        offer: 'Free Insulation Assessment',
      },
    ],
  },
  {
    serviceSlug: 'doors',
    serviceName: 'Doors',
    description:
      "Upgrade your home's entry and security. See how our reviewers ranked the top door replacement companies in your area.",
    companies: [
      {
        rank: 1,
        name: 'K-Designers Entry Doors',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium entry door options',
          'Over 140,000 satisfied customers',
          'Custom-fit door solutions',
          'Energy-efficient designs',
          'Professional installation',
          'Serving homeowners since 1978',
        ],
        offer: 'Special Savings on Entry Doors',
        partnerRoute: '/k-designers/entry-doors',
        logoUrl:
          'https://cdn.magicpatterns.com/uploads/idrKUKYXCqVbysWS3F6st9/K_Designers_Logo.png',
      },
      {
        rank: 2,
        name: 'Universal Windows Direct',
        score: 9.6,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Premium entry & patio doors',
          'True Lifetime Warranty',
          'Expert factory-trained installers',
          'Energy-efficient solutions',
          'Flexible financing options',
          'Award-winning customer service',
        ],
        offer: 'Buy 1 Get 1 FREE on Doors',
        partnerRoute: '/universal-windows-direct/doors',
      },
    ],
  },
  {
    serviceSlug: 'garage-doors',
    serviceName: 'Garage Doors',
    description:
      'Boost your curb appeal with a new garage door. See how our reviewers ranked the top garage door companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Clopay Garage Doors',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          "America's favorite garage door brand",
          'Insulated & non-insulated options',
          'Wind load rated models available',
          'Extensive design customization',
          'Limited lifetime warranty',
          'Nationwide dealer network',
        ],
        offer: 'Free Design Consultation + Estimate',
      },
      {
        rank: 2,
        name: 'Precision Door Service',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Same-day service available',
          'Repair & replacement experts',
          'Lifetime warranty on springs',
          'Smart garage door openers',
          'Upfront pricing always',
        ],
        offer: '$100 Off New Garage Door',
      },
      {
        rank: 3,
        name: 'Overhead Door Company',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          '90+ years of experience',
          'Residential & commercial',
          'Smart technology integration',
          'Energy-efficient insulated doors',
          'Professional installation',
        ],
        offer: 'Free Safety Inspection',
      },
    ],
  },
  {
    serviceSlug: 'home-security',
    serviceName: 'Home Security',
    description:
      'Protect your family and property. See how our reviewers ranked the top home security system companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'ADT Security',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          '145+ years of trusted protection',
          '24/7 professional monitoring',
          'Smart home integration',
          'Video doorbell & cameras included',
          '6-month money-back guarantee',
          'Professional installation',
        ],
        offer: 'Free Equipment + $0 Installation',
      },
      {
        rank: 2,
        name: 'Vivint Smart Home',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'AI-powered smart detection',
          'Professional-grade cameras',
          'Smart lock & thermostat integration',
          'Custom system design',
          'Award-winning app',
        ],
        offer: 'Free Professional Installation',
      },
      {
        rank: 3,
        name: 'SimpliSafe',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'No contracts required',
          'Easy DIY installation',
          'Professional monitoring from $17.99/mo',
          'Fast Protect™ technology',
          'Award-winning design',
        ],
        offer: '40% Off Security System',
      },
    ],
  },
  {
    serviceSlug: 'pest-control',
    serviceName: 'Pest Control',
    description:
      'Eliminate pests and protect your home. See how our reviewers ranked the top pest control companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Terminix',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          '90+ years of pest expertise',
          'Termite & general pest control',
          'Satisfaction guarantee included',
          'Customized treatment plans',
          'Trained & certified technicians',
          'Flexible scheduling',
        ],
        offer: '$50 Off Initial Treatment',
      },
      {
        rank: 2,
        name: 'Orkin',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Over 120 years in business',
          'A.I.M. treatment methodology',
          'Ongoing pest prevention',
          'Money-back guarantee',
          'Highly trained specialists',
        ],
        offer: 'Free Pest Inspection',
      },
      {
        rank: 3,
        name: 'Aptive Environmental',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Eco-friendly treatments',
          'Family & pet safe products',
          'Quarterly service plans',
          'No long-term contracts',
          'Fast-growing pest company',
        ],
        offer: '$50 Off First Service',
      },
    ],
  },
  {
    serviceSlug: 'landscaping',
    serviceName: 'Landscaping',
    description:
      'Create your dream outdoor space. See how our reviewers ranked the top landscaping companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'TruGreen',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          "America's #1 lawn care company",
          'Science-based lawn treatments',
          'Tailored plans for your region',
          'Satisfaction guarantee included',
          'PhD-certified specialists',
          'Year-round lawn programs',
        ],
        offer: '50% Off First Application',
      },
      {
        rank: 2,
        name: 'Lawn Love',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Instant online booking',
          'Vetted local landscapers',
          'Transparent upfront pricing',
          'Mowing, trimming & more',
          'Satisfaction guaranteed',
        ],
        offer: 'First Mow Free For New Customers',
      },
      {
        rank: 3,
        name: 'BrightView Landscapes',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Full-service landscape design',
          'Commercial & residential',
          'Irrigation & hardscape experts',
          'Seasonal maintenance plans',
          'Nationwide coverage',
        ],
        offer: 'Free Landscape Consultation',
      },
    ],
  },
  {
    serviceSlug: 'cleaning',
    serviceName: 'Cleaning',
    description:
      'Keep your home spotless with professional cleaning. See how our reviewers ranked the top cleaning service companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Molly Maid',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand trusted',
          'Customized cleaning plans',
          'Insured & bonded teams',
          'Satisfaction guarantee included',
          'Consistent, reliable scheduling',
          'Background-checked employees',
        ],
        offer: '$50 Off First Clean',
      },
      {
        rank: 2,
        name: 'Merry Maids',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          '35+ years of experience',
          'Worry-free guarantee',
          'Eco-friendly cleaning options',
          'Trained & vetted professionals',
          'Flexible scheduling',
        ],
        offer: 'Free In-Home Estimate',
      },
      {
        rank: 3,
        name: 'The Maids',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          '22-step healthy touch cleaning',
          'HEPA filtration vacuums',
          'EPA-registered disinfectants',
          'Team cleaning for faster service',
          'Satisfaction guaranteed',
        ],
        offer: '10% Off Recurring Service',
      },
    ],
  },
  {
    serviceSlug: 'general',
    serviceName: 'General Repair',
    description:
      'Tackle your home repairs with trusted handymen. See how our reviewers ranked the top general repair and handyman companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Mr. Handyman',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Wide range of repair services',
          'Upfront, flat-rate pricing',
          'Licensed & insured craftsmen',
          'Satisfaction guarantee included',
          'One call handles it all',
        ],
        offer: '$25 Off First Service',
      },
      {
        rank: 2,
        name: 'Ace Handyman Services',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Craftsmen — not subcontractors',
          'Multi-skilled professionals',
          'Background-checked & insured',
          'On-time guarantee',
          'Locally owned & operated',
        ],
        offer: 'Free Project Consultation',
      },
      {
        rank: 3,
        name: 'Handy',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Easy online booking',
          'Vetted local professionals',
          'Transparent pricing',
          'Furniture assembly to full repairs',
          'Happiness guarantee',
        ],
        offer: 'First Booking 20% Off',
      },
    ],
  },
]
